import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/featureGroup/license.featureGroup.ruleOptions.query.gql"
import type {
  FeatureGroupRuleOptionsQuery,
  FeatureGroupRuleOptionsQueryVariables,
} from "@/v2-backoffice-client/license/featureGroup/__types__/license.featureGroup.ruleOptions.query"

type Options = QueryHookOptions<
  FeatureGroupRuleOptionsQuery,
  FeatureGroupRuleOptionsQueryVariables
>

export function useFeatureGroupRuleOptionsQuery(options?: Options) {
  return useQuery<
    FeatureGroupRuleOptionsQuery,
    FeatureGroupRuleOptionsQueryVariables
  >(query, options)
}
